angular.module('mavibayrak')
  .controller('MarinasCtrl', function ($scope, $filter, $ionicPopup, $state, Marinas, Audits) {
    var marinas = Marinas.all();

    $scope.search = {
      name: '',
      city_id: '',
      town_id: ''
    };

    $scope.cities = Marinas.getCities();

    $scope.$watchCollection('search', function (newSearch, oldSearch) {
      if (newSearch.city_id != oldSearch.city_id) {
        $scope.towns = newSearch.city_id ? Marinas.getTownsOfCity(newSearch.city_id) : [];
      }
      //noinspection JSUnresolvedVariable
      if (newSearch.name.trim().length == 0 && !newSearch.city_id) {
        $scope.items = [];
      } else {
        var filter = {name: newSearch.name};
        if (newSearch.city_id) filter['city_id'] = newSearch.city_id;
        if (newSearch.town_id) filter['town_id'] = newSearch.town_id;
        var items = $filter('filter')(marinas, filter);
        $scope.items = $filter('limitTo')(items, 10);
      }
    });

    $scope.gotoMarina = function (marina) {
      var marinaId = marina.id;
      var unsavedData = Audits.unsavedData('marina', marinaId);
      if (unsavedData.length > 0) {
        var marinas = unsavedData.map(function (item) {
          return item.marina.name;
        }).join(', ');
        $ionicPopup.confirm({
          title: 'Yarım Kalmış Kayıt',
          template: marinas + ' için tamamlanmamış kaydınız bulunmaktadır.<br><br>' +
          'Devam ederseniz bu bilgiler silinecektir.<br><br>' +
          'Devam etmek istiyor musunuz?'
        }).then(function (confirmed) {
          if (confirmed) {
            $state.go('tab.marina', {marinaId: marinaId});
          }
        });
      } else {
        $state.go('tab.marina', {marinaId: marinaId});
      }
    }
  });